<template lang="pug">
page-layout#reviews(
	:heading='heading'
	:num-of-slide-outs='1'
	:class='{ "above-side-nav" : reviewPageState === "opened" }'
)
	.link-container(slot='link-container')
		//- a.alter(href='#') Alter Entry Settings
		.button(@click='reviewForm') Add New Review
	review-slide-out(
		slot='slideout-1'
		:state='reviewPageState'
		:data-state='reviewLoadingState'
		:asset='activeReview'
		:asset-key='reviewKey'
		asset-name='reviews'
		@close='reviewPageState = "closed"; activeReview = null;'
		@edit='editReview'
		@delete='deleteReview'
	)
	asset-table(
		slot='content'
		asset-name='reviews'
		asset-key='reviewsKey'
		search-text='Search for a Review'
		:config='config'
		:get-all='GetReviews'
		:get='GetReview'
		:search='SearchReviews'
		:download-csv='DownloadReviewsCSV'
		:download-pdf='DownloadReviewsPDF'
		@row-clicked='viewReview'
	)
</template>

<script>
import AssetTable from '@/components/AssetTable';
import PageLayout from '@/components/PageLayout';
import ReviewSlideOut from '@/components/slide-outs/reviews';

import {
	GetReviews,
	GetReview,
	DeleteReview,
	DownloadReviewsCSV,
	DownloadReviewsPDF,
	SearchReviews
} from '@/lib/API';

import Submit from '@/lib/Submit';
// eslint-disable-next-line no-unused-vars
import { FilterToAPI,	SortToAPI } from '@/lib/utils';
import { editReview } from '@/lib/generate';
import ReviewConfigs from '@/lib/assets/devUtilReviews';

export default {
	name : 'dev-util-reviews',

	data : () => ( {

		heading : {
			title       : 'Developer and Utility Reviews',
			description : 'Click any row to view the reviews in full',
		},

		config : {
			columns : ReviewConfigs.columns,

			// for if you have any columns that have a dropdown
			// for it's filtering
			dropdownOptions : ReviewConfigs.dropdownOptions,
		},

		reviewPageState    : 'closed',
		reviewLoadingState : 'loaded',
		activeReview       : null,
		reviewKey          : null,

		GetReviews,
		GetReview,
		DownloadReviewsCSV,
		DownloadReviewsPDF,
		SearchReviews

	} ),

	created() {
		const { query } = this.$route;
		const { key }   = query;

		if ( key ) {
			this.viewReview( { reviewsKey : key } );
		}
	},

	computed : {

		customMethods() {
			return {
				downloadCSV : DownloadReviewsCSV,
				downloadPDF : DownloadReviewsPDF,
				getAssets   : GetReviews,
				getAsset    : GetReview,
				search      : SearchReviews,
			};
		}

	},

	methods : {

		reviewForm() {
			this.$store.dispatch( 'form', {
				type : 'review',
			} )
				.then( async ( form ) => {

					const stateIndicator = await this.$store.dispatch( 'displayState', {
						message : 'Creating Developer and Utility Review...',
						state   : 'loading'
					} );

					Submit.review( form )
						.then( form.close() )
						.then( () => stateIndicator.resolve( 'Created Successfully' ) )
						.catch( () => {
							form.close();
							stateIndicator.fail( { header : 'Didn\'t Create Developer and Utility Review', message : '' } );
						} );
				} );
		},

		viewReview( { reviewsKey } ) {

			this.activeReview = null;
			this.reviewKey    = null;

			this.reviewPageState    = 'opened';
			this.reviewLoadingState = 'loading';

			const displayStateOptions = {
				message        : 'Loading Review',
				successMessage : 'Review Loaded',
				failMessage    : 'Review could not be loaded.',
				state          : 'loading',
			};

			this.$store.dispatch( 'loadWithDisplayState', {
				options : displayStateOptions,
				method  : () => GetReview( reviewsKey ),
			} )
				.then( ( review ) => {
					this.reviewLoadingState = 'loaded';
					this.activeReview       = review;
					this.reviewKey          = review.reviewsKey;
				} )
				.catch( () => {
					this.reviewLoadingState = 'failed';
				} );

		},

		closeReview() {
			this.reviewPageState = 'closed';
			this.activeReview    = null;
		},

		editReview() {
			const { reviewsKey, location } = this.activeReview;

			if ( location )	this.activeReview.locationDescription = location.description;
			else this.activeReview.locationDescription = ' ';

			if ( this.activeReview.location ) delete this.activeReview.location;

			const startingData   = editReview( this.activeReview );

			this.$store.dispatch( 'form', {
				type : 'review',
				args : [{ edit : true }],
				startingData,
			} )
				.then( async ( form ) => {

					const stateIndicator = await this.$store.dispatch( 'displayState', {
						message : 'Editing Developer and Utility Review...',
						state   : 'loading'
					} );

					form.close();


					Submit.editReview( form, reviewsKey )
						.then( () => stateIndicator.resolve( 'Edited Successfully' ) )
						.then( () => this.viewReview( { reviewsKey } ) )
						.catch( () => {
							form.close();
							stateIndicator.fail( { header : 'Didn\'t Edit Developer and Utility Review', message : '' } );
						} );
				} );
		},

		async deleteReview() {

			const stateIndicator = await this.$store.dispatch( 'displayState', {
				message : 'Deleting Developer and Utility Review...',
				state   : 'loading'
			} );

			DeleteReview( this.activeReview.reviewsKey )
				.then( () => stateIndicator.resolve( 'Deleted Successfully' ) )
				.then( this.reviewPageState = 'closed' )
				.catch( ( err ) => {

					console.error( err );

					stateIndicator.fail( { header : 'Didn\'t Delete Developer and Utility Review', message : '' } );

				} );

		},

	},

	components : {
		AssetTable,
		PageLayout,
		ReviewSlideOut,
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.space-form.review-form {
	@include set-form-color( #BA8080 );

	.drop-box-wrapper .background {
		background: lighten( #BA8080, 30% );
	}
}
</style>
